<fui-filter-fascia *ngIf="!icon" (clicked$)="click()" [disabled]="disabled" [focussed]="focussed" [hovered]="hovered" [ngClass]="'clickable'">
    <fui-fixtures>
        <fui-spanning-fixture>
            <fui-input-dom>
                <input (blur)="onBlur($event)" [readonly]="true" #input (focus)="onFocus($event)"
                       [placeholder]="placeholder | translate" [size]="(placeholder | translate).length"
                       [tabindex]="tabindex" type="text">
            </fui-input-dom>
        </fui-spanning-fixture>
        <fui-fixture>
            <fui-mark-toggle [toggled]="popped">
                <fui-icon [width]="12" [height]="6" [icon]="'chevron-down'"></fui-icon>
            </fui-mark-toggle>
        </fui-fixture>
    </fui-fixtures>
</fui-filter-fascia>
<fui-action *ngIf="icon" [forceIcon]="true" [attr.title]="placeholder | translate" (click)="click()" [disabled]="disabled">
    <ng-content select="fui-icon" ngProjectAs="fui-icon"></ng-content>
</fui-action>
<fui-select-pop [popped]="popped" (popped$)="pop($event)" [limitWidthToParent]="false"
                [parentHorizontalAlignment]="PopParentHorizontalAlignment.RIGHT">
    <fui-sections>
        <fui-section>
            <fui-multiselect-options [field]="field" [key]="key" [options]="options" id="options"
                                     [filteredOptions]="filteredOptions" (selections$)="select($event)"></fui-multiselect-options>
        </fui-section>
    </fui-sections>
</fui-select-pop>
